const ITEMS = [
  "Smart maintenance",
  "Service history",
  "Engine hours",
  "Fuel tracking",
  "AI receipt scan",
  "Reminders",
  "Warranty radar",
  "Read-only shares",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-[#0C1D38] py-5"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif-display px-6 text-xl italic text-slate-300 sm:text-2xl">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-[#1D8A99]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
